<p-dialog [(visible)]="exibeCadastro" [style]="{width: '900px'}" [header]="cadastroTitulo" [modal]="true"
  styleClass="p-fluid" (onHide)="hideDialog()">
  <ng-template pTemplate="content">
    <div class="p-fluid p-formgrid p-grid">

      <!-- Checkbox para alternar entre formulário e upload -->
      <!-- <div *ngIf="state === 1" class="p-field p-col-12">
        <p-checkbox [binary]="true" label="Preenchimento via Arquivo" [disabled]="state === 0"
          (onChange)="alteraFormulario()">
        </p-checkbox>
      </div> -->

      <!-- Formulário Manual -->
      <ng-container *ngIf="isForm">
        <div class="p-field p-grid p-col-12">
          <div class="p-field p-col-6">
            <label>Regional:</label>
            <input type="text" pInputText [(ngModel)]="cadastro.descricao_regiao" maxlength="100" [disabled]="state === 0">
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.descricao_regiao">Regional é Obrigatório!</small>
          </div>

          <div class="p-field p-col-6">
            <label>Nome Contato:</label>
            <input type="text" pInputText [(ngModel)]="cadastro.nome_contato" maxlength="50" [disabled]="state === 0">
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.nome_contato">Nome do contato é Obrigatório!</small>
          </div>
        </div>

        <div class="p-field p-grid p-col-12">
          <div class="p-field p-col-2">
            <label>DDD:</label>
            <p-inputMask mask="(99)" [(ngModel)]="cadastro.ddd_contato" placeholder="DDD" unmask="true" [disabled]="state === 0"></p-inputMask>
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.ddd_contato">DDD é Obrigatório!</small>
          </div>

          <div class="p-field p-col-4">
            <label>Telefone:</label>
            <p-inputMask mask="9999-9999" [(ngModel)]="cadastro.telefone_contato" placeholder="Telefone do Contato..." [disabled]="state === 0"
            unmask="true"></p-inputMask>
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.telefone_contato">Telefone é Obrigatório!</small>
          </div>

          <div class="p-field p-col-6">
            <label>Email:</label>
            <input type="email" pInputText [(ngModel)]="cadastro.email_contato" maxlength="100" [disabled]="state === 0">
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.email_contato">Email é Obrigatório!</small>
          </div>
        </div>
      </ng-container>

      <!-- Upload via Arquivo -->
      <ng-container *ngIf="!isForm">
        <div class="jumbotron">
          <div class="row">
            <div class="col-10">
              <legend>1. Faça download do modelo de planilha</legend>
              <legend>2. Preencha os campos corretamente</legend>
              <legend>3. Faça upload do arquivo preenchido</legend>
            </div>
            <div class="col-2">
              <div class="float-right mr-4">
                <a class="btn download" href="assets/modelos/modelo-previsao-venda.xlsx">
                  <i class="fas fa-file-download"></i>
                </a>
                Baixar Modelo
              </div>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="state == 1">
          <div class="col col-lg-12">
            <p class="text-info">Adicione o arquivo Excel com os dados dos regionais para importação:</p>
            <p-fileUpload mode="advanced" fileLimit="1" name="arquivo[]" customUpload="true" accept=".xlsx"
              (uploadHandler)="uploader($event)">
            </p-fileUpload>
          </div>
        </div>
      </ng-container>

    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button *ngIf="state !== 0 && isForm" pButton label="Salvar" icon="pi pi-check" class="p-button-text"
      (click)="saveDados()">
    </button>
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
  </ng-template>
</p-dialog>
